import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../../firebase";
import "./login.css";

const Login = () => {
  const [data, setData] = useState({
    email: "",
    password: "",
    error: null,
    loading: false,
  });

  let navigate = useNavigate();

  const { email, password, error, loading } = data;

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setData({ ...data, error: null, loading: true });
    if (!email || !password) {
      setData({ ...data, error: "All fields are required" });
    }
    try {
      const result = await signInWithEmailAndPassword(auth, email, password);

      await updateDoc(doc(db, "users", result.user.uid), {
        isOnline: true,
      });

      setData({
        email: "",
        password: "",
        error: null,
        loading: false,
      });
      navigate("/");
    } catch (err) {
      setData({ ...data, error: err.message, loading: false });
    }
  };

  return (
    <div className="login">
      <div className="login-form">
        <h1>Login to Your Account</h1>

        <form onSubmit={handleSubmit}>
          <label>Email</label>
          <br />
          <input
            name="email"
            value={email}
            onChange={handleChange}
            type="email"
            placeholder="Example@email.com"
          />
          <br />
          <label>Password</label>
          <br />
          <input
            name="password"
            type="password"
            value={password}
            onChange={handleChange}
            placeholder="Enter Password"
          />
          <br />
          <button className="submit-btn" disabled={loading} type="Submit">
            {loading ? "Logging in ..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
